import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { post } from '../http';
import { activeSnack } from './common';

// --- API THUNKS START ---
export const getAllPortfolio = createAsyncThunk('portfolio/list', async ({ search, dispatch }) => {
  try {
    const response = await post(`/portfolio/advertiser/all?search=${search || ''}`);
    if (response) {
      return response;
    }
    return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});

export const getAllAdGroup = createAsyncThunk(
  'ad-group/list',
  async ({ page, search,campaignIds,dispatch }) => {
    try {
      const response = await post(
        `/ad-group/advertiser/all?page=${page || page}&search=${search || ''}`, {campaignIds}
      );
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const getAllTarget = createAsyncThunk('target/list', async ({ page, search, dispatch }) => {
  try {
    const response = await post(
      `/targeting-clause/advertiser/all?page=${page || page}&search=${search || ''}`
    );
    if (response) {
      return response;
    }
    return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});

export const getAllKeywordsTargets = createAsyncThunk(
  'target/list',
  async ({ page, search, dispatch }) => {
    console.log('new api called');

    try {
      const response = await post(
        `/keyword/advertiser/all?page=${page || page}&search=${search || ''}`
      );
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const getAllSearchTerm = createAsyncThunk(
  'search-term/list',
  async ({ page, search, dispatch }) => {
    try {
      const response = await post(
        `/search-term/advertiser/all?page=${page || page}&search=${search || ''}`
      );
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const getAllProducts = createAsyncThunk(
  'products/list',
  async ({ page, search, dispatch }) => {
    try {
      const response = await post(
        `/product-ad/advertiser/all?page=${page || page}&search=${search || ''}`
      );
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
// --- REDUX SLICE START ---
export const dropDownListReducerSlicer = createSlice({
  name: 'dropDownListReducer',
  initialState: {
    loading: false,
    error: {},
    allPortfolio: {},
    allAdGroups: {},
    allTargets: {},
    allKeywordTargets: {},
    allProducts: {},
    allSearchTerm: {},
  },
  reducers: {
    clearStaffError: (state) => {
      state.error = true;
    },
  },
  extraReducers: {
    [getAllPortfolio.pending]: (state) => {
      state.loading = true;
    },
    [getAllPortfolio.fulfilled]: (state, action) => {
      state.loading = false;
      state.allPortfolio = action?.payload;
      state.error = {};
    },
    [getAllPortfolio.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [getAllAdGroup.pending]: (state) => {
      state.loading = true;
    },
    [getAllAdGroup.fulfilled]: (state, action) => {
      state.loading = false;
      state.allAdGroups = action.payload;
      state.error = {};
    },
    [getAllAdGroup.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [getAllTarget.pending]: (state) => {
      state.loading = true;
    },
    [getAllTarget.fulfilled]: (state, action) => {
      state.loading = false;
      state.allTargets = action.payload;
      state.error = {};
    },
    [getAllTarget.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    [getAllKeywordsTargets.pending]: (state) => {
      state.loading = true;
    },
    [getAllKeywordsTargets.fulfilled]: (state, action) => {
      state.loading = false;
      state.allKeywordTargets = action.payload;
      state.error = {};
    },
    [getAllKeywordsTargets.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    [getAllSearchTerm.pending]: (state) => {
      state.loading = true;
    },
    [getAllSearchTerm.fulfilled]: (state, action) => {
      state.loading = false;
      state.allSearchTerm = action.payload;
      state.error = {};
    },
    [getAllSearchTerm.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [getAllProducts.pending]: (state) => {
      state.loading = true;
    },
    [getAllProducts.fulfilled]: (state, action) => {
      state.loading = false;
      state.allProducts = action.payload;
      state.error = {};
    },
    [getAllProducts.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});
export const { clearStaffError } = dropDownListReducerSlicer.actions;

export default dropDownListReducerSlicer.reducer;
